





































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { InternalStatus, XvOrdersHistoryResp_Order, XvSetOrderStatusReq } from '@/apiv3/index'
import auth from '@/auth'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

@Component({ components: { PulseLoader } })
export default class XvOrdersHistory extends Vue {
  public InternalStatus = InternalStatus
  public orders!: XvOrdersHistoryResp_Order[]
  public loaded = false
  public currentStatus = InternalStatus.CANCELLED
  public blocked = false

  mounted () {
    auth.adminClient().XvOrdersHistory({}).then((resp) => {
      this.orders = resp.orders
    }).finally(() => {
      this.loaded = true
    })
  }

  filtered (): XvOrdersHistoryResp_Order[] {
    const list: XvOrdersHistoryResp_Order[] = []

    this.orders.forEach((val) => {
      if (val.internalStatus !== this.currentStatus) {
        return
      }

      list.push(val)
    })

    return list
  }

  public toPrepay (order: XvOrdersHistoryResp_Order) {
    this.blocked = true

    const req: XvSetOrderStatusReq = { id: order.id, status: InternalStatus.TO_PREPAY }

    auth.adminClient().XvSetOrderStatus(req).then(() => {
      order.internalStatus = InternalStatus.TO_PREPAY
    }).finally(() => {
      this.blocked = false
    })
  }
}
